import { colors, spacing, typography } from '@lamimed/pantheon';
import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: ${spacing.xxlarge} 0 0 0;
`;

export const List = styled.ul`
  ${typography.body_text_1};
  margin-left: ${spacing.medium};
`;
export const Item = styled.li`
  color: ${colors.text__primary};
  margin-top: ${spacing.small};
`;
